module.exports = __webpack_public_path__ + "img/lowcode-2-3.0a04d719.svg";